export default "__VITE_ASSET__Vq2Ev9Z$__"